import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { initializeIcons } from "@fluentui/react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { store } from "@maven-rest/states";

import "@maven-surface/assets/style/index.scss";

initializeIcons();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

console && console.log && console.log(`> ${process.env.REACT_APP_STAGE}`);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
